// @flow weak

import {GET, POST, PUT} from '../helpers/request';
import {ADD as NOTIFICATION} from './notification';
import {FILE_UPLOAD} from '../middleware/fileUploader';
import {STANDARD, ADDITIONAL} from '../assortments';
import uuid from 'uuid';
import _ from 'lodash/fp';
import {sortByName} from './apartmentConfigView';

export const REQUEST = '@productView/REQUEST';
export const SUCCESS = '@productView/SUCCESS';
export const FAILURE = '@productView/FAILURE';

export const UPDATE_REQUEST = '@productView/UPDATE_REQUEST';
export const UPDATE_SUCCESS = '@productView/UPDATE_SUCCESS';
export const UPDATE_FAILURE = '@productView/UPDATE_FAILURE';

export const CREATE_REQUEST = '@productView/CREATE_REQUEST';
export const CREATE_SUCCESS = '@productView/CREATE_SUCCESS';
export const CREATE_FAILURE = '@productView/CREATE_FAILURE';

export const VARIANT_UPDATE_REQUEST = '@productView/VARIANT_UPDATE_REQUEST';
export const VARIANT_UPDATE_SUCCESS = '@productView/VARIANT_UPDATE_SUCCESS';
export const VARIANT_UPDATE_FAILURE = '@productView/VARIANT_UPDATE_FAILURE';

export const SET_ACTIVE_VARIANT = '@productView/SET_ACTIVE_VARIANT';
export const RESET = '@productView/RESET';
export const CLEAR = '@productView/CLEAR';

export const TOGGLE_REPLACEMENT_DIALOG = '@productView/TOGGLE_REPLACEMENT_DIALOG';
export const REPLACEMENT_PRODUCTS_REQUEST = '@productView/REPLACEMENT_PRODUCTS_REQUEST';
export const REPLACEMENT_PRODUCTS_SUCCESS = '@productView/REPLACEMENT_PRODUCTS_SUCCESS';
export const REPLACEMENT_PRODUCTS_FAILURE = '@productView/REPLACEMENT_PRODUCTS_FAILURE';
export const REPLACEMENT_VARIANTS_REQUEST = '@productView/REPLACEMENT_VARIANTS_REQUEST';
export const REPLACEMENT_VARIANTS_SUCCESS = '@productView/REPLACEMENT_VARIANTS_SUCCESS';
export const REPLACEMENT_VARIANTS_FAILURE = '@productView/REPLACEMENT_VARIANTS_FAILURE';

export const SET_ACTIVE_PRODUCT_LINKED_ADDITIONAL_VARIANT = '@productView/SET_ACTIVE_PRODUCT_LINKED_ADDITIONAL_VARIANT';
export const REMOVE_PRODUCT_LINKED_ADDITIONAL_VARIANT = '@productView/REMOVE_PRODUCT_LINKED_ADDITIONAL_VARIANT';
export const ADD_PRODUCT_LINKED_ADDITIONAL_VARIANT = '@productView/ADD_PRODUCT_LINKED_ADDITIONAL_VARIANT';
export const UPDATE_PRODUCT_LINKED_ADDITIONAL_VARIANT = '@productView/UPDATE_PRODUCT_LINKED_ADDITIONAL_VARIANT';

export const SET_ACTIVE_VARIANT_LINKED_ADDITIONAL_VARIANT = '@productView/SET_ACTIVE_VARIANT_LINKED_ADDITIONAL_VARIANT';
export const REMOVE_VARIANT_LINKED_ADDITIONAL_VARIANT = '@productView/REMOVE_VARIANT_LINKED_ADDITIONAL_VARIANT';
export const ADD_VARIANT_LINKED_ADDITIONAL_VARIANT = '@productView/ADD_VARIANT_LINKED_ADDITIONAL_VARIANT';
export const UPDATE_VARIANT_LINKED_ADDITIONAL_VARIANT = '@productView/UPDATE_VARIANT_LINKED_ADDITIONAL_VARIANT';

export const ADDITIONAL_PRODUCTS_REQUEST = '@productView/ADDITIONAL_PRODUCTS_REQUEST';
export const ADDITIONAL_PRODUCTS_SUCCESS = '@productView/ADDITIONAL_PRODUCTS_SUCCESS';
export const ADDITIONAL_PRODUCTS_FAILURE = '@productView/ADDITIONAL_PRODUCTS_FAILURE';
export const ADDITIONAL_VARIANTS_REQUEST = '@productView/ADDITIONAL_VARIANTS_REQUEST';
export const ADDITIONAL_VARIANTS_SUCCESS = '@productView/ADDITIONAL_VARIANTS_SUCCESS';
export const ADDITIONAL_VARIANTS_FAILURE = '@productView/ADDITIONAL_VARIANTS_FAILURE';

export const REMOVE_VARIANT_IMAGE = '@productView/REMOVE_VARIANT_IMAGE';
export const VARIANT_IMAGE = '@productView/VARIANT_IMAGE';
export const VARIANT_IMAGE_UPLOADED = '@productView/VARIANT_IMAGE_UPLOADED';
export const SET_DEFAULT_VARIANT_IMAGE = '@productView/SET_DEFAULT_VARIANT_IMAGE';
export const SET_ACTIVE_VARIANT_IMAGE = '@productView/SET_ACTIVE_VARIANT_IMAGE';

export const SUPPLIERS_REQUEST = '@productView/SUPPLIERS_REQUEST';
export const SUPPLIERS_SUCCESS = '@productView/SUPPLIERS_SUCCESS';
export const SUPPLIERS_FAILURE = '@productView/SUPPLIERS_FAILURE';

export const ROOM_TYPES_REQUEST = '@productView/ROOM_TYPES_REQUEST';
export const ROOM_TYPES_SUCCESS = '@productView/ROOM_TYPES_SUCCESS';
export const ROOM_TYPES_FAILURE = '@productView/ROOM_TYPES_FAILURE';

export const WORKER_TYPES_REQUEST = '@productView/WORKER_TYPES_REQUEST';
export const WORKER_TYPES_SUCCESS = '@productView/WORKER_TYPES_SUCCESS';
export const WORKER_TYPES_FAILURE = '@productView/WORKER_TYPES_FAILURE';

export const PRODUCT_TYPES_REQUEST = '@productView/PRODUCT_TYPES_REQUEST';
export const PRODUCT_TYPES_SUCCESS = '@productView/PRODUCT_TYPES_SUCCESS';
export const PRODUCT_TYPES_FAILURE = '@productView/PRODUCT_TYPES_FAILURE';

export const FILTER_ARCHIVED = '@productView/FILTER_ARCHIVED';

export const SET_RELATED_PRODUCT_TYPE = '@productView/SET_RELATED_PRODUCT_TYPE';
export const RELATED_PRODUCT_SELECTED = '@productView/RELATED_PRODUCT_SELECTED';
export const RELATED_VARIANT_SELECTED = '@productView/RELATED_VARIANT_SELECTED';
export const RELATED_PRODUCT_TOGGLE = '@productView/RELATED_PRODUCT_TOGGLE';
export const RELATED_PRODUCT_TYPE_TOGGLE = '@productView/RELATED_PRODUCT_TYPE_TOGGLE';
export const ADD_RELATED_PRODUCT_TYPE_REQUEST = '@productView/ADD_RELATED_PRODUCT_TYPE_REQUEST';
export const ADD_RELATED_PRODUCT_TYPE_SUCCESS = '@productView/ADD_RELATED_PRODUCT_TYPE_SUCCESS';
export const ADD_RELATED_PRODUCT_TYPE_FAILURE = '@productView/ADD_RELATED_PRODUCT_TYPE_FAILURE';

export const SET_SHARED_RELATED_PRODUCT_TYPE = '@productView/SET_SHARED_RELATED_PRODUCT_TYPE';
export const SHARED_RELATED_PRODUCT_SELECTED = '@productView/SHARED_RELATED_PRODUCT_SELECTED';
export const SHARED_RELATED_VARIANT_SELECTED = '@productView/SHARED_RELATED_VARIANT_SELECTED';
export const SHARED_RELATED_PRODUCT_TOGGLE = '@productView/SHARED_RELATED_PRODUCT_TOGGLE';
export const SHARED_RELATED_PRODUCT_TYPE_TOGGLE = '@productView/SHARED_RELATED_PRODUCT_TYPE_TOGGLE';
export const ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS = '@productView/ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS';

export const VARIANTS_UPDATE_REQUEST = '@productView/VARIANTS_UPDATE_REQUEST';
export const VARIANTS_UPDATE_SUCCESS = '@productView/VARIANTS_UPDATE_SUCCESS';
export const VARIANTS_UPDATE_FAILURE = '@productView/VARIANTS_UPDATE_FAILURE';

export const RELATED_PRODUCT_TYPE_SELECTED = '@productView/RELATED_PRODUCT_TYPE_SELECTED';
export const SHARED_RELATED_PRODUCT_TYPE_SELECTED = '@productView/SHARED_RELATED_PRODUCT_TYPE_SELECTED';
export const REMOVE_PRODUCT_TYPE = '@productView/REMOVE_PRODUCT_TYPE';
export const SHARED_REMOVE_PRODUCT_TYPE = '@productView/SHARED_REMOVE_PRODUCT_TYPE';

export const UNLOCK_SHARED = '@productView/UNLOCK_SHARED';

export const unlockShared = () => ({
  type: UNLOCK_SHARED,
});

export const removeProductType = (variantId, id) => ({
  type: REMOVE_PRODUCT_TYPE,
  id,
  variantId,
});

export const sharedRemoveProductType = id => ({
  type: SHARED_REMOVE_PRODUCT_TYPE,
  id,
});

export const relatedProductSelected = (variantId, id, selected) => ({
  type: RELATED_PRODUCT_SELECTED,
  id,
  selected,
  variantId,
});

export const relatedVariantSelected = (variantId, id, selected) => ({
  type: RELATED_VARIANT_SELECTED,
  id,
  selected,
  variantId,
});

export const relatedProductToggle = (variantId, id) => ({
  type: RELATED_PRODUCT_TOGGLE,
  id,
  variantId,
});

export const relatedProductTypeToggle = (variantId, id) => ({
  type: RELATED_PRODUCT_TYPE_TOGGLE,
  id,
  variantId,
});

const addRelatedProductTypeRequest = () => ({
  type: ADD_RELATED_PRODUCT_TYPE_REQUEST,
});

const addRelatedProductTypeSuccess = (variantId, productType, products) => ({
  type: ADD_RELATED_PRODUCT_TYPE_SUCCESS,
  productType,
  products,
  variantId,
});

const addRelatedProductTypeFailure = error => ({
  type: ADD_RELATED_PRODUCT_TYPE_FAILURE,
  error,
});

export const addRelatedProductType = (variantId, productType) => async dispatch => {
  dispatch(addRelatedProductTypeRequest());
  try {
    const products = await GET({endpoint: `/products?productTypeId=${productType.id}&assortment=${STANDARD}`}, dispatch);
    dispatch(addRelatedProductTypeSuccess(variantId, productType, products));
  } catch (err) {
    dispatch(addRelatedProductTypeFailure(err));
  }
};

export const setRelatedProductType = relatedProductType => ({
  type: SET_RELATED_PRODUCT_TYPE,
  relatedProductType,
});

const sharedRelatedProductSelectedSuccess = (id, productType, products, selected) => ({
  type: SHARED_RELATED_PRODUCT_SELECTED,
  id,
  productType,
  products,
  selected,
});

export const sharedRelatedProductSelected = (id, productType, selected) => async dispatch => {
  dispatch(addRelatedProductTypeRequest());
  try {
    const products = await GET({endpoint: `/products?productTypeId=${productType.id}&assortment=${STANDARD}`}, dispatch);
    dispatch(sharedRelatedProductSelectedSuccess(id, productType, products, selected));
  } catch (err) {
    dispatch(addRelatedProductTypeFailure(err));
  }
};

export const relatedProductTypeSelected = (variantId, id, selected) => ({
  type: RELATED_PRODUCT_TYPE_SELECTED,
  id,
  selected,
  variantId,
});

const sharedRelatedProductTypeSelectedSuccess = (productType, products, selected) => ({
  type: SHARED_RELATED_PRODUCT_TYPE_SELECTED,
  productType,
  products,
  selected,
});

export const sharedRelatedProductTypeSelected = (productType, selected) => async dispatch => {
  dispatch(addRelatedProductTypeRequest());
  try {
    const products = await GET({endpoint: `/products?productTypeId=${productType.id}&assortment=${STANDARD}`}, dispatch);
    dispatch(sharedRelatedProductTypeSelectedSuccess(productType, products, selected));
  } catch (err) {
    dispatch(addRelatedProductTypeFailure(err));
  }
};

const sharedRelatedVariantSelectedSuccess = (id, productType, products, selected) => ({
  type: SHARED_RELATED_VARIANT_SELECTED,
  id,
  productType,
  products,
  selected,
});

export const sharedRelatedVariantSelected = (id, productType, selected) => async dispatch => {
  dispatch(addRelatedProductTypeRequest());
  try {
    const products = await GET({endpoint: `/products?productTypeId=${productType.id}&assortment=${STANDARD}`}, dispatch);
    dispatch(sharedRelatedVariantSelectedSuccess(id, productType, products, selected));
  } catch (err) {
    dispatch(addRelatedProductTypeFailure(err));
  }
};

export const sharedRelatedProductToggle = id => ({
  type: SHARED_RELATED_PRODUCT_TOGGLE,
  id,
});

export const sharedRelatedProductTypeToggle = id => ({
  type: SHARED_RELATED_PRODUCT_TYPE_TOGGLE,
  id,
});

const addSharedRelatedProductTypeSuccess = (productType, products) => ({
  type: ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS,
  productType,
  products,
});

export const addSharedRelatedProductType = productType => async dispatch => {
  dispatch(addRelatedProductTypeRequest());
  try {
    const products = await GET({endpoint: `/products?productTypeId=${productType.id}&assortment=${STANDARD}`}, dispatch);
    dispatch(addSharedRelatedProductTypeSuccess(productType, products));
  } catch (err) {
    dispatch(addRelatedProductTypeFailure(err));
  }
};

export const setSharedRelatedProductType = relatedProductType => ({
  type: SET_SHARED_RELATED_PRODUCT_TYPE,
  relatedProductType,
});

const productRequest = () => ({
  type: REQUEST,
});

const productSuccess = (product, variants, variantId) => ({
  type: SUCCESS,
  product,
  variants,
  variantId,
});

const productFailure = error => ({
  type: FAILURE,
  error,
});

const productUpdateRequest = () => ({
  type: UPDATE_REQUEST,
});

const productUpdateSuccess = product => ({
  type: UPDATE_SUCCESS,
  product,
  [NOTIFICATION]: {
    message: 'Produkt uppdaterad',
  },
});

const productUpdateFailure = error => ({
  type: UPDATE_FAILURE,
  error,
});

const productCreateRequest = () => ({
  type: CREATE_REQUEST,
});

const productCreateSuccess = (product, variants) => ({
  type: CREATE_SUCCESS,
  product,
  variants,
  [NOTIFICATION]: {
    message: `Produkt "${product.name}" skapad`,
  },
});

const productCreateFailure = error => ({
  type: CREATE_FAILURE,
  error,
});

const productVariantUpdateRequest = () => ({
  type: VARIANT_UPDATE_REQUEST,
});

const productVariantUpdateSuccess = variant => ({
  type: VARIANT_UPDATE_SUCCESS,
  variant,
  [NOTIFICATION]: {
    message: 'Variant uppdaterad',
  },
});

const productVariantUpdateFailure = error => ({
  type: VARIANT_UPDATE_FAILURE,
  error,
});

const productVariantsUpdateRequest = () => ({
  type: VARIANTS_UPDATE_REQUEST,
});

const productVariantsUpdateSuccess = variants => ({
  type: VARIANTS_UPDATE_SUCCESS,
  variants,
  [NOTIFICATION]: {
    message: 'Variant uppdaterad',
  },
});

const productVariantsUpdateFailure = error => ({
  type: VARIANTS_UPDATE_FAILURE,
  error,
});

const replacementProductsRequest = () => ({
  type: REPLACEMENT_PRODUCTS_REQUEST,
});

const replacementProductsSuccess = products => ({
  type: REPLACEMENT_PRODUCTS_SUCCESS,
  products,
});

const replacementProductsFailure = error => ({
  type: REPLACEMENT_PRODUCTS_FAILURE,
  error,
});

const replacementVariantsRequest = () => ({
  type: REPLACEMENT_VARIANTS_REQUEST,
});

const replacementVariantsSuccess = variants => ({
  type: REPLACEMENT_VARIANTS_SUCCESS,
  variants,
});

const replacementVariantsFailure = error => ({
  type: REPLACEMENT_VARIANTS_FAILURE,
  error,
});

const additionalProductsRequest = () => ({
  type: ADDITIONAL_PRODUCTS_REQUEST,
});

const additionalProductsSuccess = products => ({
  type: ADDITIONAL_PRODUCTS_SUCCESS,
  products,
});

const additionalProductsFailure = error => ({
  type: ADDITIONAL_PRODUCTS_FAILURE,
  error,
});

const additionalVariantsRequest = () => ({
  type: ADDITIONAL_VARIANTS_REQUEST,
});

const additionalVariantsSuccess = variants => ({
  type: ADDITIONAL_VARIANTS_SUCCESS,
  variants,
});

const additionalVariantsFailure = error => ({
  type: ADDITIONAL_VARIANTS_FAILURE,
  error,
});

export const fetchProduct = (id, variantId, copy) => async dispatch => {
  dispatch(productRequest());
  try {
    if (copy) {
      const product = await GET({endpoint: `/products/${id}/copy`}, dispatch);
      const variants = await GET({endpoint: `/products/${id}/variants/copy?fullRelated=1`}, dispatch);

      dispatch(productSuccess(product, variants, product.mainVariantId));
    } else {
      const product = await GET({endpoint: `/products/${id}`}, dispatch);
      const variants = await GET({endpoint: `/products/${id}/variants?fullRelated=1`}, dispatch);
      dispatch(productSuccess(product, variants, variantId ? parseInt(variantId, 10) : null));
    }
  } catch (err) {
    dispatch(productFailure(err));
  }
};

export const updateProduct = (id, body) => async dispatch => {
  dispatch(productUpdateRequest());
  try {
    const product = await PUT({
      endpoint: `/products/${id}`,
      body,
    }, dispatch);
    dispatch(productUpdateSuccess(product));
  } catch (err) {
    dispatch(productUpdateFailure(err));
  }
};

export const createProduct = body => async dispatch => {
  dispatch(productCreateRequest());
  try {
    let product;

    if (!body.copy) {
      product = await POST({
        endpoint: '/products',
        body,
      }, dispatch);
    } else {
      delete body.variants;
      product = await POST({
        endpoint: '/products/copy',
        body,
      }, dispatch);
    }

    const variants = await GET({endpoint: `/products/${product.id}/variants?fullRelated=1`}, dispatch);
    dispatch(productCreateSuccess(product, variants));
  } catch (err) {
    dispatch(productCreateFailure(err));
  }
};

export const updateProductVariant = (id, body) => async dispatch => {
  dispatch(productVariantUpdateRequest());
  try {
    const variant = await PUT({
      endpoint: `/productvariants/${id}`,
      body,
    }, dispatch);
    dispatch(productVariantUpdateSuccess(variant));
  } catch (err) {
    dispatch(productVariantUpdateFailure(err));
  }
};

export const updateProductVariants = (id, body) => async dispatch => {
  dispatch(productVariantsUpdateRequest());
  try {
    const variants = await PUT({
      endpoint: `/products/${id}/variants`,
      body,
    }, dispatch);
    dispatch(productVariantsUpdateSuccess(variants));
  } catch (err) {
    dispatch(productVariantsUpdateFailure(err));
  }
};

export const fetchReplacementProducts = () => async dispatch => {
  dispatch(replacementProductsRequest());
  try {
    const products = await GET({endpoint: `/products?assortment=${STANDARD}`}, dispatch);
    dispatch(replacementProductsSuccess(products));
  } catch (err) {
    dispatch(replacementProductsFailure(err));
  }
};

export const fetchReplacementVariants = id => async dispatch => {
  dispatch(replacementVariantsRequest());
  try {
    const variants = await GET({endpoint: `/products/${id}/variants`}, dispatch);
    dispatch(replacementVariantsSuccess(variants));
  } catch (err) {
    dispatch(replacementVariantsFailure(err));
  }
};

export const fetchAdditionalProducts = () => async dispatch => {
  dispatch(additionalProductsRequest());
  try {
    const products = await GET({endpoint: `/products?assortment=${ADDITIONAL}`}, dispatch);
    const nonArchivedProducts = _.filter({archived: null}, products);
    dispatch(additionalProductsSuccess(nonArchivedProducts));
  } catch (err) {
    dispatch(additionalProductsFailure(err));
  }
};

export const fetchAdditionalVariants = id => async dispatch => {
  dispatch(additionalVariantsRequest());
  try {
    const variants = await GET({endpoint: `/products/${id}/variants`}, dispatch);
    const nonArchivedVariants = _.filter({archived: null}, variants);
    dispatch(additionalVariantsSuccess(nonArchivedVariants));
  } catch (err) {
    dispatch(additionalVariantsFailure(err));
  }
};

export const setActiveVariant = variant => ({
  type: SET_ACTIVE_VARIANT,
  variant,
});

export const toggleReplacementDialog = show => ({
  type: TOGGLE_REPLACEMENT_DIALOG,
  show,
});

export const setActiveProductLinkedAdditionalVariant = additional => ({
  type: SET_ACTIVE_PRODUCT_LINKED_ADDITIONAL_VARIANT,
  additional,
});

export const addProductLinkedAdditionalVariant = additional => ({
  type: ADD_PRODUCT_LINKED_ADDITIONAL_VARIANT,
  additional,
});

export const updateProductLinkedAdditionalVariant = additional => ({
  type: UPDATE_PRODUCT_LINKED_ADDITIONAL_VARIANT,
  additional,
});

export const removeProductLinkedAdditionalVariant = additional => ({
  type: REMOVE_PRODUCT_LINKED_ADDITIONAL_VARIANT,
  additional,
});

export const setActiveVariantLinkedAdditionalVariant = additional => ({
  type: SET_ACTIVE_VARIANT_LINKED_ADDITIONAL_VARIANT,
  additional,
});

export const addVariantLinkedAdditionalVariant = additional => ({
  type: ADD_VARIANT_LINKED_ADDITIONAL_VARIANT,
  additional,
});

export const updateVariantLinkedAdditionalVariant = additional => ({
  type: UPDATE_VARIANT_LINKED_ADDITIONAL_VARIANT,
  additional,
});

export const removeVariantLinkedAdditionalVariant = additional => ({
  type: REMOVE_VARIANT_LINKED_ADDITIONAL_VARIANT,
  additional,
});

export const reset = () => ({
  type: RESET,
});

export const clear = () => ({
  type: CLEAR,
});

const variantImageUploaded = variantId => (tempId, metadata) => ({
  type: VARIANT_IMAGE_UPLOADED,
  variantId,
  tempId,
  metadata,
});

export const variantImage = (variantId, file) => ({
  type: VARIANT_IMAGE,
  tempId: uuid.v4(),
  variantId,
  [FILE_UPLOAD]: {
    file,
    success: variantImageUploaded(variantId),
  },
});

export const removeVariantImage = (variantId, imageId, isTemp = false) => ({
  type: REMOVE_VARIANT_IMAGE,
  variantId,
  imageId,
  isTemp,
});

export const setDefaultVariantImage = image => ({
  type: SET_DEFAULT_VARIANT_IMAGE,
  image,
});

export const setActiveVariantImage = image => ({
  type: SET_ACTIVE_VARIANT_IMAGE,
  image,
});

const suppliersRequest = () => ({
  type: SUPPLIERS_REQUEST,
});

const suppliersSuccess = suppliers => ({
  type: SUPPLIERS_SUCCESS,
  suppliers,
});

const suppliersFailure = error => ({
  type: SUPPLIERS_FAILURE,
  error,
});

export const fetchSuppliers = () => async dispatch => {
  dispatch(suppliersRequest());
  try {
    const suppliers = sortByName(await GET({endpoint: '/suppliers'}, dispatch));
    dispatch(suppliersSuccess(suppliers));
  } catch (err) {
    dispatch(suppliersFailure(err));
  }
};

const roomTypesRequest = () => ({
  type: ROOM_TYPES_REQUEST,
});

const roomTypesSuccess = roomTypes => ({
  type: ROOM_TYPES_SUCCESS,
  roomTypes,
});

const roomTypesFailure = error => ({
  type: ROOM_TYPES_FAILURE,
  error,
});

export const fetchRoomTypes = () => async dispatch => {
  dispatch(roomTypesRequest());
  try {
    const roomTypes = sortByName(await GET({endpoint: '/roomtypes'}, dispatch));
    dispatch(roomTypesSuccess(roomTypes));
  } catch (err) {
    dispatch(roomTypesFailure(err));
  }
};

const workerTypesRequest = () => ({
  type: WORKER_TYPES_REQUEST,
});

const workerTypesSuccess = workerTypes => ({
  type: WORKER_TYPES_SUCCESS,
  workerTypes,
});

const workerTypesFailure = error => ({
  type: WORKER_TYPES_FAILURE,
  error,
});

export const fetchWorkerTypes = () => async dispatch => {
  dispatch(workerTypesRequest());
  try {
    const workerTypes = sortByName(await GET({endpoint: '/workertypes'}, dispatch));
    dispatch(workerTypesSuccess(workerTypes));
  } catch (err) {
    dispatch(workerTypesFailure(err));
  }
};

const productTypesRequest = () => ({
  type: PRODUCT_TYPES_REQUEST,
});

const productTypesSuccess = productTypes => ({
  type: PRODUCT_TYPES_SUCCESS,
  productTypes,
});

const productTypesFailure = error => ({
  type: PRODUCT_TYPES_FAILURE,
  error,
});

export const fetchProductTypes = () => async dispatch => {
  dispatch(productTypesRequest());
  try {
    const productTypes = sortByName(await GET({endpoint: '/producttypes'}, dispatch));
    dispatch(productTypesSuccess(productTypes));
  } catch (err) {
    dispatch(productTypesFailure(err));
  }
};

export const filterArchived = includeArchived => ({
  type: FILTER_ARCHIVED,
  includeArchived,
});



// WEBPACK FOOTER //
// ./src/actions/productView.js